<div class="main-container">
  <umkt-header></umkt-header>

  <main class="main-content">
    <ng-content></ng-content>
  </main>

  <umkt-footer></umkt-footer>

  <umkt-mobile-navbar></umkt-mobile-navbar>

  @if (chatbotEnabled && (onlyIndicationService.isOnlyIndicationActive$ | async) === false) {
    <umkt-chatbot></umkt-chatbot>
  }
</div>
